import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import {
	BatchUpdateProviderPresetResponse,
	BatchUpdateProviderPresetRequest,
} from '../../../type'
import { batchUpdateProviderPreset } from '../../services'

export default function useMutationBatchUpdateProviderPreset(
	props?: UseBaseMutationOptions<
		BatchUpdateProviderPresetResponse,
		BatchUpdateProviderPresetRequest
	>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.BatchUpdateProviderPreset],
		mutationFn: (payload) => batchUpdateProviderPreset(payload),
		...props,
	})
}
